import { PageTitle } from 'src/components/PageTitle';

import styles from './styles.module.css';

export const AddDevice = () => {
  return (
    <div className={styles.devices}>
      <PageTitle title="Add Device" />
    </div>
  );
};
